import React, { useEffect, useMemo, useState } from "react";
import { Box, OutlinedInput } from "@mui/material";
import { ModalDefault } from "../../../../components/ModalDefault";
import { sxCard, sxTitle } from "./sxProps";
import "./styles.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import { useAccessibility } from "../../../../Store/contexts/AccessibilityContext";
import DefaultTextBold from "../../../../components/Accessibility/DefaultTextBold";
import { getAllAtalhos } from "../../../../services/Home/HomeService";
import LoadingApp from "../../../../components/LoadingApp";
import { MenuItem } from "../../../../interfaces/Home/MenuItem";

interface AtalhoModalProps {
  open: boolean;
  atalhosSelecionados: MenuItem[];
  onSelect: (item: MenuItem) => void;
  onClose: () => void;
}

const AtalhoModal: React.FC<AtalhoModalProps> = ({ open, atalhosSelecionados, onSelect, onClose }) => {
  const { contrastColorAccessibility } = useAccessibility();
  const [search, setSearch] = useState<string>("");
  const [allAtalhos, setAllAtalhos] = useState<MenuItem[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    const fetchAtalhos = async () => {
      setLoading(true);
      try {
        const response = await getAllAtalhos();
        setAllAtalhos(response);
      } finally {
        setLoading(false);
      }
    };

    fetchAtalhos();
  }, []);

  const availableAtalhos = useMemo(() => {
    return allAtalhos.filter(
      (atalho) =>
        !atalhosSelecionados.some((item) => item.title === atalho.title) &&
        !atalho.restricted &&
        atalho.title.toLowerCase().includes(search.toLowerCase())
    );
  }, [allAtalhos, atalhosSelecionados, search]);

  useEffect(() => {
    if (!open) {
      setSearch('')
    }
  }, [open])

  return (
    <>
      <ModalDefault
        open={open}
        title="Adicionar atalhos"
        sxTitle={sxTitle}
        className="modal-atalho"
        onClose={onClose}
      >
        <div className="modal-atalho-container">
          <OutlinedInput
            placeholder="Pesquisar"
            fullWidth
            endAdornment={<FontAwesomeIcon icon={faMagnifyingGlass} />}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
          <div className="modal-atalho-list">
            {loading ? (
              <LoadingApp showLoading />
            ) : availableAtalhos.length ? (
              availableAtalhos.map((item) => (
                <Box key={item.title}
                  sx={sxCard}
                  onClick={() => onSelect(item)}
                  tabIndex={0}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      e.preventDefault();
                      onSelect(item);
                    }
                  }}>
                  <FontAwesomeIcon
                    icon={item.icon}
                    color="#00995d"
                    style={{ ...contrastColorAccessibility }}
                  />
                  <DefaultTextBold text={item.title} />
                </Box>
              ))
            ) : (
              <p>Nenhum atalho disponível.</p>
            )}
          </div>
        </div>
      </ModalDefault>
    </>
  );
};

export default AtalhoModal;
